// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"Custom404_emptyWrapper__9XGxC","emptyText":"Custom404_emptyText__r87VD"};